<template>
  <div class="carousel">
    <el-card shadow="nerver">
      <el-button type="primary" @click="addReasons" size="mini"
        >添加好处</el-button
      >

      <el-button @click="resetHomepage('9')" size="small">重置</el-button>

      <div class="table-style">
        <el-table :data="tableData">
          <el-table-column prop="title" label="标题"></el-table-column>

          <el-table-column prop="content" label="内容"></el-table-column>
          <el-table-column prop="id" label="图片">
            <template slot-scope="scope">
              <el-image
                style="width: 100px; height: 80px"
                :src="scope.row.img_url"
                fit="cover"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="updateReasons(scope.row)"
                >修改</el-button
              >
              <el-button
                size="mini"
                type="text"
                @click="deleteReasons(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div>
          <div style="margin-top: 20px;">是否显示</div>
          <el-card style="margin-top: 20px;" shadow="never">
            <el-switch
              v-model="whylearn_is_show1"
              active-text="开启"
              inactive-text="关闭"
              @change="changwhylearn"
            >
            </el-switch>
          </el-card>
        </div>
      </div>
    </el-card>

    <el-dialog title="添加好处" :visible.sync="dialogVisible" width="540px">
      <el-form class="form-style" ref="form" :model="form" :rules="rules">
        <el-form-item label="标题" required prop="title">
          <el-input
            placeholder="请输入标题"
            v-model="form.title"
            style="width: 400px"
            maxlength="30"
            show-word-limit
          >
          </el-input>
        </el-form-item>

        <el-form-item label="内容" required prop="content">
          <el-input
            placeholder="请输入内容"
            v-model="form.content"
            style="width: 400px"
            maxlength="30"
            show-word-limit
          >
          </el-input>
        </el-form-item>

        <el-form-item label="选择图片" required prop="fileList">
          <el-upload
            action=""
            :http-request="uploadFile"
            :on-remove="handleRemove"
            :on-change="handleChangeFile"
            :auto-upload="false"
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="form.fileList"
            list-type="picture"
            style="width: 400px"
          >
            <el-button size="mini" type="primary" plain>点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              <span style="margin-left: 10px">推荐尺寸: 480px * 380px</span>
              <span style="margin-left: 10px">
                只能上传jpg/png文件，且不超过500kb</span
              >
            </div>
          </el-upload>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit('form')" size="small"
          >保 存</el-button
        >
        <el-button @click="quitDialog('form')" size="small">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  deleteReasons,
  uploadReasons,
  updateReasons,
  resetHomepage,
} from '@/api/homeset'
import uploadFile from '@/config/uploadFile'
import { updateHomepage } from '@/api/homeset'

export default {
  name: 'reasons',
  props: {
    whylearn_title_one: String,
    whylearn_title_two: String,
    homepageWhyLearn: Array,
    homepage_id: Number,
    whylearn_is_show: Boolean,
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (!value.length) {
        callback(new Error('请上传图片'))
      } else {
        callback()
      }
    }
    return {
      whylearn_is_show1: true,
      imageId: '',
      form: {
        title: '',
        content: '',
        fileList: [],
      },
      tableData: [],
      dialogVisible: false,
      rules: {
        title: [
          { required: true, message: '请填写标题', trigger: 'blur' },
          { required: true, message: '请填写标题', trigger: 'change' },
        ],
        content: [
          { required: true, message: '请填写内容介绍', trigger: 'blur' },
          { required: true, message: '请填写内容介绍', trigger: 'change' },
        ],
        fileList: [{ validator: validatePass, trigger: 'change' }],
      },
      uploadFileTime: false,
    }
  },
  watch: {
    whylearn_is_show() {
      this.whylearn_is_show1 = this.whylearn_is_show
    },
    homepageWhyLearn() {
      this.tableData = this.homepageWhyLearn
    },
  },
  methods: {
    changwhylearn() {
      updateHomepage({
        id: this.homepage_id,
        whylearn_title_one: this.whylearn_title_one,
        whylearn_title_two: this.whylearn_title_two,
        whylearn_is_show: this.whylearn_is_show1 === false ? '0' : '1',
      }).then((res) => {
        if (res.is_update) {
          this.$message.success('保存成功！')
        }
      })
    },
    addReasons() {
      this.form.title = ''
      this.form.content = ''
      this.form.fileList = []
      this.imageId = ''
      this.dialogVisible = true
    },

    quitDialog(formName) {
      this.$refs[formName].resetFields()
      this.dialogVisible = false
    },
    updateReasons(row) {
      this.imageId = row.id
      this.form.title = row.title
      this.form.content = row.content
      this.form.fileList = [
        {
          url: row.img_url,
          name: row.img_url.split('/')[row.img_url.split('/').length - 1],
        },
      ]
      this.dialogVisible = true
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.imageId) {
            updateReasons({
              id: this.imageId,
              title: this.form.title,
              content: this.form.content,
              img_url: this.form.fileList[0].url,
              homepage_id: this.homepage_id,
            }).then((res) => {
              if (res.is_update) {
                this.$message.success('更新成功!')
                this.dialogVisible = false
                this.tableData = this.tableData.map((item) =>
                  item.id === res.result.id ? res.result : item
                )
              }
            })
          } else {
            uploadReasons({
              title: this.form.title,
              content: this.form.content,
              img_url: this.form.fileList[0].url,
              homepage_id: this.homepage_id,
            }).then((res) => {
              if (res.is_create) {
                this.$message.success('上传成功！')
                this.dialogVisible = false
                this.tableData.push(res.result)
              }
            })
          }
        }
      })
    },
    uploadFile() {},
    handleRemove(file, fileList) {
      this.form.fileList = fileList
    },

    handleExceed() {
      this.$message.warning('请删除原有文件,再重新上传')
    },

    async handleChangeFile(file, fileList) {
      if (file.size > 1024 * 500) {
        // 500kb
        this.form.fileList.pop()
        return this.$message.warning('图片不符合规则，请重新上传！')
      } else {
        if (!this.uploadFileTime) {
          await this.uploadFileOss(fileList)
        }
      }
    },
    async uploadFileOss(list) {
      this.uploadFileTime = true
      await uploadFile(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          this.form.fileList = res
          this.uploadFileTime = false
        }
      )
    },
    deleteReasons(row) {
      this.$confirm('确定删除本条数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteReasons({
          id: row.id,
        }).then((res) => {
          if (res.is_delete) {
            this.$message.success('删除成功！')

            for (var i = 0; i < this.tableData.length; i++) {
              if (this.tableData[i].id === row.id) {
                this.tableData.splice(i, 1)
              }
            }
          }
        })
      })
    },

    //重置校区信息
    resetHomepage(type) {
      this.$confirm('确定重置学编程好处吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        resetHomepage({
          reset_type: type,
        }).then((res) => {
          console.log('重置信息')
          console.log(res)
          if (res.is_update) {
            this.$message.success('重置成功,请刷新本页面')
          }
        })
      })
    },
  },
}
</script>

<style scoped lang="scss">
.carousel {
  height: 100%;
  background-color: #fff;

  .table-style {
    margin-top: 20px;
    padding-bottom: 20px;
  }
}

/deep/.el-dialog {
  border-radius: 10px !important;
}
</style>
